import type { IBlackbaudAuthenticatedUser } from '@feathr/blackbox';

/** The Blackbaud user who connected the integration, as the kit summary card shows it. */
export function getConnectedBy(
  user: IBlackbaudAuthenticatedUser | undefined,
): { name: string } | null {
  // A record made before OAuth completes can hold an empty or partial user.
  const name = [user?.given_name, user?.family_name].filter(Boolean).join(' ');
  return name ? { name } : null;
}
